import { Component, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login-onboard-co-pick-modal',
  templateUrl: './login-onboard-co-pick-modal.component.html',
  styleUrls: ['./login-onboard-co-pick-modal.component.css']
})
export class LoginOnboardCoPickModalComponent {

  @Input() companies: any;
  constructor(private activeModal: NgbActiveModal) {}

  itemClicked(prco: number) {
    this.activeModal.close(prco);
  }

  close() {
    this.activeModal.close();
  }
}
